import { createFileRoute } from "@tanstack/react-router";
import GrantDetail from "@/pages/GrantDetail";

export const Route = createFileRoute("/subvenciones/$codigo")({
  component: GrantDetail,
});
